import moment from "moment";
import Vue from "vue";
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";

import { router } from "@/router";
import _ from "lodash";
import store from "@/store";
import { getHardwareId, getResourceUsageInfo } from "@/socket.io/init";


function initialState() {
  return {
    posShiftLog: {
      paymentTypes: [],
      grandTotal: 0,
      cine_include_shift_close: null,
      //
      usl_id: null,
      user_shift_id: null
      // hardware_setting_id: null,
      // login_date_time: null,
      // shift_end: null,
      // logout_date_time: null
    }
  };
}

const state = initialState();

const mutations = {
  SET_USER_SHIFT_DETAILS: (state, payload) => {
    state.posShiftLog = {
      ...state.posShiftLog,
      ...payload
    };
  },
  SET_POS_USER_SHIFT_PAYMENT_TYPES: (state, payload) => {
    state.posShiftLog.paymentTypes = [];
    payload.map(x => {
      x["no_of_slips"] = 0;
      x["amount"] = 0;
      x["remark"] = "";
      state.posShiftLog.paymentTypes.push(x);
      return x;
    });
    // state.posShiftLog.paymentTypes = payload;
  },
  SET_POS_USER_SHIFT_PAYMENT_CASH_TOTAL: (state, payload) => {
    state.posShiftLog.paymentTypes = state.posShiftLog.paymentTypes.map(x => {
      if (String(x.pm_id) === "1") {
        x["amount"] = payload;
      }
      return x;
    });
  },
  SET_POS_USER_SHIFT_PAYMENT_GRAND_TOTAL: (state, payload) => {
    state.posShiftLog.grandTotal = state.posShiftLog.paymentTypes.reduce(
      (acc, { amount }) => acc + parseFloat(amount),
      0
    );
  },
  SET_POS_USER_SHIFT_PAYMENT_VALUE: (state, { index, name, value }) => {
    state.posShiftLog.paymentTypes[index][name] =
      value && value.length > 0 && value.replace(/\s/g, "").length > 0
        ? parseFloat(value)
        : 0;
  },
  RESET_POS_CLOSE_SHIFT_DATA: (state, payload) => {
    state.posShiftLog.grandTotal = 0;
  }
};

const actions = {
  onPosShiftClosePaymentHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_POS_USER_SHIFT_PAYMENT_VALUE", payload);
    await commit("SET_POS_USER_SHIFT_PAYMENT_GRAND_TOTAL");
  },
  onPosShiftClosePaymentCash: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_POS_USER_SHIFT_PAYMENT_CASH_TOTAL", payload);
    await commit("SET_POS_USER_SHIFT_PAYMENT_GRAND_TOTAL");
  },
  userShiftStart: async ({ dispatch, commit, state }, payload) => {
    console.log("payload :::::", payload);
    let loader = Vue.$loading.show();
    // await commit("SET_USER_SHIFT_DETAILS", payload);

    let hardwareMacAddress = window.localStorage.getItem("hardware_mac_address");
    let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
    if(!hardwareId || !hardwareMacAddress) {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        let sys_info = await getResourceUsageInfo();
        const key = Object.keys(sys_info.macAddress)[0];
        hardwareMacAddress = sys_info.macAddress[key].mac;
      }
    }

    let requestPayload = {
      ...state.posShiftLog,
      hardware_id: window.localStorage.getItem("HWUID") ? window.localStorage.getItem("HWUID") : window.localStorage.getItem("deiviceUniqueCode")
        ? window.localStorage.getItem("deiviceUniqueCode")
        : null,
      hardware_name: window.localStorage.getItem("hardware_name") ? window.localStorage.getItem("hardware_name") : null,
      hardware_mac_address: window.localStorage.getItem("hardware_mac_address")
        ? window.localStorage.getItem("hardware_mac_address")
        : hardwareMacAddress ? hardwareMacAddress : null,
    }
    PosService.OnStartPosUserShiftLog(requestPayload)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          commit("SET_USER_SHIFT_DETAILS", data.Records);
          if (!data.Records["inserted_new"]) {
            // USE WHEN WE NEED TO FORCE CLOSE SHIFT
            // router.replace({
            //     path: "close-shift"
            // });

            if (payload["page_name"] && payload["page_name"] == "FNB_LOGIN") {
              router.replace({
                path: "pos-fnb"
              });
            } else {
              // PASS DIRECTLY ON BOOKING WIHTOUT ASKING FLOAT AMOUNT
              router.replace({
                path: "pos-booking"
              });
            }
          } else if (
            payload["page_name"] &&
            payload["page_name"] == "FNB_LOGIN"
          ) {
            if (
              payload["cine_include_float_amount"] &&
              payload["cine_include_float_amount"] == "Y"
            ) {
              router.replace({
                path: "pos-fnb-cash-input"
              });
            } else {
              router.replace({
                path: "pos-fnb"
              });
            }
          } else if (
            payload["cine_include_float_amount"] &&
            payload["cine_include_float_amount"] == "Y"
          ) {
            router.replace({
              path: "pos-cash-input"
            });
          } else {
            router.replace({
              path: "pos-booking"
            });
          }
        } else {
        }
      })
      .catch(error => {})
      .finally(() => {
        setTimeout(() => loader.hide(), 1000);
      });
  },
  // onGetUserShifts: async ({ dispatch, commit, state }, { user_id, ...payload }) => {
  //     PosService.OnGetPosUserShiftLog({ user_id })
  //         .then((response) => {
  //             const { data } = response;
  //             console.log('OnGetPosUserShiftLog data :', data);
  //             if (data && data.status) {
  //             } else {

  //             }
  //         }).catch((error) => {

  //         });
  // },
  onUserShiftQuit: async ({ dispatch, commit, state }, payload) => {
    PosService.OnQuitPosUserShift(state.posShiftLog)
      .then(response => {
        const { data } = response;
        console.log("onUserShiftQuit data :", data);
      })
      .catch(error => {});
  },
  clearShiftData: async ({ dispatch, commit, state }, payload) => {
    await commit("RESET_POS_CLOSE_SHIFT_DATA");
  },
  userPosShiftClose: async ({ dispatch, commit, state }, payload) => {
    PosService.OnClosePosUserShiftLog(state.posShiftLog)
      .then(response => {
        const { data } = response;
        console.log("OnClosePosUserShiftLog data :", data);
      })
      .catch(error => {});
  },
  getPosUsersShiftPaymentTypes: async (
    { dispatch, commit, state },
    payload
  ) => {
    let body = {
      //   tableName: "ms_payment_modes",
      //   pm_is_active: "Y"
      bs_id: 1
    };
    MasterService.GetPaymentModes(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_POS_USER_SHIFT_PAYMENT_TYPES", data.Records)
            : "";
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  }
};

const getters = {
  getUserShiftLog: state => state.posShiftLog,
  getUserShiftPaymentTypes: state => state.posShiftLog.paymentTypes,
  getUserShiftPaymentGrandTotal: state => state.posShiftLog.grandTotal
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/PosShiftLog.js